var map = {
	"./ts1.png": "55f8",
	"./ts10.png": "9226",
	"./ts11.png": "0031",
	"./ts12.png": "ce0c",
	"./ts13.png": "0306",
	"./ts14.png": "1ca9",
	"./ts15.png": "2fdb",
	"./ts16.png": "8499",
	"./ts17.png": "0e35",
	"./ts18.png": "8f0c",
	"./ts19.png": "11fb",
	"./ts2.png": "5885",
	"./ts20.png": "4bbf",
	"./ts21.png": "070a",
	"./ts22.png": "efc6",
	"./ts3.png": "a12b",
	"./ts4.png": "15c8",
	"./ts5.png": "1ad8",
	"./ts6.png": "964d",
	"./ts7.png": "3ad6",
	"./ts8.png": "4d5b",
	"./ts9.png": "319b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ee28";